import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'

import {
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'

import SortableImageItem from './SortableImageItem'
import OverlayImageItem from './OverlayImageItem'
import Grid from '../../../common/Grid'

import { pinAds } from '../../../../actions/proShopActions'


const ConfigPageCustomItemPreview = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.user.current_user)
  const communityAds = useSelector(state => state.proShop.community_ads)
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  useEffect(() => {
    const images_ = communityAds.pinned_ads.map(
      pinnedAdId => communityAds.coach_ads.find(coachAd => coachAd.id === pinnedAdId)
    )

    setImages(images_)
  }, [communityAds])

  const [images, setImages] = useState([])
  const [activeId, setActiveId] = useState(null)

  const handleDragStart = useCallback((event) => {
    setActiveId(event.active.id)
  }, [])

  const handleDragCancel = useCallback(() => {
    setActiveId(null)
  }, [])

  const handleDragEnd = useCallback((event) => {
    const { active, over } = event

    if (active.id !== over.id) {
      setImages((images) => {
        const imagesIds = images.map(image => image.id)
        const oldIndex = imagesIds.indexOf(active.id)
        const newIndex = imagesIds.indexOf(over.id)
        const newImages = arrayMove(images, oldIndex, newIndex)

        dispatch(
          pinAds(
            currentUser.communities[0].id,
            newImages.map(image => image.id)
          )
        )

        return newImages
      })
    }
  }, [dispatch, currentUser])

  if (!images.length) {
    return null
  }

  return (
    <div className='config-item-selected-image-container'>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}
        onDragCancel={handleDragCancel}
      >
        <SortableContext
          items={images}
          strategy={rectSortingStrategy}
        >
          <Grid columns={3} gap={12}>
            {images.map((image, index) =>
              <SortableImageItem key={image.id} image={image} index={index} />
            )}
          </Grid>
        </SortableContext>
        <DragOverlay adjustScale style={{ transformOrigin: '0 0 ' }}>
          {activeId ? (
            <OverlayImageItem
              image={images.find(image => image.id === activeId)}
              isDragging
            />
          ) : null}
        </DragOverlay>
      </DndContext>
    </div>
  )
}

export default ConfigPageCustomItemPreview
